<template>
  <div class='appointment-details__dates-modal'>
    <div class='md:grid grid-cols-12 mb-5'>
      <div class='col-span-5'>
        <h3 class='modal__title'>{{ commonChooseDateTime }}</h3>
      </div>
      <div class='col-span-7 flex items-center gap-2 mt-1'>
        <theme-input
          :value='dateComputed'
          :isExtraInfo='true'
          :isReadonly='true'
        >
          <template slot='extra-info'>
            <i class='icon-calendar'/>
          </template>
        </theme-input>
      </div>
    </div>
    <functional-calendar
      :date-format="'dd-mm-yyyy'"
      :is-date-picker="true"
      @choseDay='changeDate'
      :calendars-count='2'
      :is-multiple='true'
    />
    <div class="flex justify-between items-start gap-4 mb-6">
      <theme-input
        v-model="hours"
        :label="commonHours"
        v-validate="`min_value:0|max_value:23|numeric|required`"
      ></theme-input>

      <theme-input
        v-model="minutes"
        :label="commonMinutes"
        v-validate="`min_value:0|max_value:59|numeric|required`"
      ></theme-input>
    </div>
    <div class='flex justify-between'>
      <span class='theme-btn theme-btn--text' @click='resetValues'>
          <i class='icon-replay' style='font-size: 20px;'></i>
          {{ commonResetValues }}
      </span>
      <button 
        type="button"
        class="theme-btn theme-btn--theme"
        :class="{'theme-btn--theme-disabled': !isValuesOkay}"
        @click='saveValues'
      >
          {{ commonSaveAndClose }}
      </button>
    </div>
  </div>
</template>

<script>
  import {FunctionalCalendar} from 'vue-functional-calendar';

  export default {
    $_veeValidate: {
      validator: "new",
    },
    components: {FunctionalCalendar},
    data() {
      return {
        selectedDate: { date: '' },
        hours: '',
        minutes: '',
      };
    },
    props: {
      commonChooseDateTime: {
        default: '',
        type: String,
      },
      commonHours: {
        default: '',
        type: String,
      },
      commonMinutes: {
        default: '',
        type: String,
      },
      commonResetValues: {
        default: '',
        type: String,
      },
      commonSaveAndClose: {
        default: '',
        type: String,
      },
    },
    computed: {
      dateComputed() {
        return this.selectedDate.date ? this.selectedDate.date : '';
      },
      isValuesOkay() {
        return this.selectedDate.date &&  (this.hours != '' && this.hours > -1 && this.hours < 24) && (this.minutes != '' && this.minutes > -1 && this.minutes < 59);
      },
    },
    methods: {
      resetValues: function() {
        this.selectedDate = { date: '' };
        this.hours = '';
        this.minutes = '';
      },
      saveValues: function() {
        this.$emit('update_values', { date: this.selectedDate.date, hours: this.hours, minutes: this.formatMinutes(this.minutes) });
        this.$emit('close_modal');
      },
      changeDate: function (value) {
        this.selectedDate = { date: value.date }
      },
      formatMinutes: function(input) {
        const minutes = parseInt(input, 10);
        return minutes < 10 ? `0${minutes}` : `${minutes}`;
      }
    },
  };
</script>